import React, { useState, useRef } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import CreateShelfModal from 'components/admin/shelf/CreateShelfModal';

import { adminShelfApi } from 'api';

import {
  ADMIN_SHELF_LIST_TAB,
  ADMIN_SHELF_LIST_COLUMNS,
  ADMIN_SHELF_FILTER_OPTIONS,
} from 'constants/admin/shelf';

const Shelf = () => {
  const tableRef = useRef();
  const [showCreateShelfModal, setShowCreateShelfModal] = useState(false);

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateShelfModal(true)}
    >
      Create Shelf
    </Button>
  );

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Shelf"
        apiService={adminShelfApi}
        sortable={true}
        columns={ADMIN_SHELF_LIST_COLUMNS}
        filterOptions={ADMIN_SHELF_FILTER_OPTIONS}
        tabOptions={ADMIN_SHELF_LIST_TAB}
        headerActions={headerActions}
      />

      <CreateShelfModal
        show={showCreateShelfModal}
        onHide={() => setShowCreateShelfModal(false)}
        onSuccess={handleActionSuccess}
      />
    </>
  );
};

export default Shelf;
